import React, { useState, useEffect, useContext } from 'react';
import {Route, Routes} from "react-router-dom";

import Rp_Home from './rp/home.js';
import Rp_List from './rp/list.js';
import Rp_Rps from './rp/rps.js';
import Rp_Rvs from './rp/rvs.js';
import Rp_Trs from './rp/trs.js';
import Op_Home from "./op/home";
import {withRouter} from "../lib/react/withRouter";
import sso from "../sso";

function pg_home() {

    var html =
    <div className="web-content">
      Hem
    </div>
    ;
    return html;
}

class Pms_Fo extends React.Component {
    //var sdo = useContext(SDO);
  constructor(props, context) {
    super(props);

    this.webStore = props.store;
    this.state = { pgid: 11, deps: [] };
    //context.posrend = this;
  }
  fknGo(row) {
    //alert(row.href);
    this.props.store.fkn = row;
      sso.seo.sfkn = row;
    this.props.navigate(row.url);
  }
    br_css(row) {
        var css = {};
        if(sso.seo.sfkn && (row.url == sso.seo.sfkn.url)) css.color = "#080";
        //var brc = false;
        //if(row.url == sbo.state.url) brc = true;
        return css;
    }

  render() {
      var path = window.location.pathname;
      if(path.substr(-1) == "/") path = path.substring(0, path.length - 1);
      var op = path.split("/").pop();
      var po = {};
      po.list = { "fid": "f06", "url": "/pms/rp/list", "name": "Listor", "active": false };
      po.rps = { "fid": "f06", "url": "/pms/rp/rps", "name": "Rapporter", "active": false };
      po.rvs = { "fid": "f06", "url": "/pms/rp/rvs", "name": "Bokningar", "active": false };
      po.trs = { "fid": "f06", "url": "/pms/rp/trs", "name": "Transaktioner", "active": false };
      if(po[op]) {
          po[op].active = true;
          //this.props.store.fkn = po[op];
      }
      var pa = Object.values(po);

    return (
    <div className="web-app">
         { this.props.store.cfg.bread ?
        <div className="web-bread">
            <div className="breadcrumb">
            { pa.map((row, key) =>
                <div className="breadcrumb-item" key={key} style={this.br_css(row)} onClick={() => this.fknGo(row)}>{row.name}</div>
            )}
            <div className="flex"></div>
            <div className="cdigreen">{ this.props.store.fkn ? this.props.store.fkn.name : null }</div>
            </div>
        </div>
        : null }
        <Routes>
          <Route path="/xx" component={pg_home} />
            <Route path="list" element={ <Rp_List store={this.webStore} />} />
            <Route path="rps" element={ <Rp_Rps store={this.webStore} />} />
            <Route path="rvs" element={ <Rp_Rvs store={this.webStore} />} />
            <Route path="trs" element={ <Rp_Trs store={this.webStore} />} />
            <Route path="*" element={ <Rp_Home store={this.webStore} />} />
        </Routes>
    </div>

  );
}
}
//Sys.contextType = ADOContext;

export default withRouter(Pms_Fo);
